import ThemedAvatar from 'shared/components/Themed/Avatar'
import Grid from '@precis-digital/kurama/Grid'
import Typography from '@precis-digital/kurama/Typography'
import { useTranslation } from 'shared/translations'

interface FormLabelProps {
  labelText: React.ReactNode
  labelChip?: React.ReactNode
  required?: boolean
  iconUrl?: string
  secondaryLabel?: React.ReactNode
  renderLabel?: (labelText: React.ReactNode) => React.ReactNode
  renderSecondaryLabel?: (secondaryLabel: React.ReactNode) => React.ReactNode
}

const FormLabel = ({
  labelText,
  required,
  iconUrl,
  secondaryLabel,
  labelChip,
  renderLabel,
  renderSecondaryLabel
}: FormLabelProps): React.ReactElement => {
  const { t } = useTranslation('common')

  return (
    <>
      <Grid display="flex" gap="8px" alignItems="center">
        {iconUrl != null && <ThemedAvatar size="small" kind="image" imageUrl={iconUrl} />}
        {renderLabel != null ? renderLabel(labelText) : <Typography variant="h5">{labelText}</Typography>}
        {required !== undefined && (
          <Typography variant="body3">{required ? t('form.required') : t('form.optional')}</Typography>
        )}
        {labelChip}
      </Grid>
      {renderSecondaryLabel != null ? (
        renderSecondaryLabel(secondaryLabel)
      ) : (
        <Typography variant="body3">{secondaryLabel}</Typography>
      )}
    </>
  )
}

export default FormLabel
